import React from 'react';
import { Provider} from 'react-redux';
import ReactDOM from 'react-dom';
// App.js
import App from './App';
// redux 
import store from './redux/strore';

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
